<template>
    <transition name="fade">
        <div class="player" name="ppPdfView" v-if="visible">
            <div class="pdf-content">

                <iframe :src="src"></iframe>

            </div>
        </div>

        <!--<div class="popup pdf" v-if="visible" name="ppPresentationView">-->
            <!--<div :class="['popup-content', {'mobile': isMobile}]">-->
                <!--<div class="popup-close" @click="visible = false"></div>-->
                <!--<div class="popup-body">-->
                    <!--<div class="scroll_frame">-->
                        <!--<iframe :src="src"></iframe>-->
                    <!--</div>-->
                    <!---->
                    <!--<div class="pdf-close" @click.stop="visible = false"></div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
    </transition>

</template>

<script>
    import UI from '../helpers/ui-helpers'

    export default {
        name: "presentation-viewer",

        props: ['title'],

        data(){
            return {
                src: null,
                page: 1,
                visible: false,
                isMobile: UI.check_mobile()
            }
        },

        methods:{
            show(url, page) {
                let vm = this;

                vm.visible = true;
                vm.src = url;
                vm.page = page;

                vm.$nextTick(() => {
                    let $ppView = $('[name=ppPdfView]');
                    let ppWidth = $ppView.width(),
                        ppHeight = $ppView.height();

                    $('[name=ppPdfView] iframe').height(ppHeight + 'px');
                    $('[name=ppPdfView] iframe').width(ppWidth + 'px');
                });
            },

            receiveMessage(message){
                if(message.data && typeof(message.data) === 'string' && message.data.startsWith('SlideChange|')){
                    let page = parseInt(message.data.replace('SlideChange|', ''));
                    this.$emit('onPageChanged', page);
                }
            }
        },

        created(){
            //window.addEventListener('keydown', this.onkey);
            window.addEventListener("message", this.receiveMessage, false);
        },

        mounted () {
            //$('body').append(this.$el);
        }
    }
</script>

<style>
    .pagefade-enter-active, .pagefade-leave-active {
        transition: all linear 0.05s;
    }
    .pagefade-enter, .pagefade-leave-to {
        opacity: 0;
    }

</style>


// WEBPACK FOOTER //
// Content/src/components/PresentationViewer.vue